import DeauvilleSeptember2026 from "../../components/before-after/DeauvilleSeptember2026";

const DeauvilleSeptember2026View = () => {

    return (
        <div className="before-after-deauville-september-2026">
            <DeauvilleSeptember2026/>
        </div>
    );
};

export default DeauvilleSeptember2026View;
